import Config from '../config/Config'
import axios from 'axios'
import { setupAxiosOktaInterceptors } from '../config/AxiosInterceptors'
import { CountryResponse } from '../common/hooks/useCountriesList'

export const rebookingDeliveryViewClient = setupAxiosOktaInterceptors(
  axios.create({
    baseURL: `${Config.REBOOKING_DELIVERYVIEW_URL}`,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
)

export const fetchCountries = async (): Promise<CountryResponse[]> => {
  return rebookingDeliveryViewClient.get(`/countries`).then((response) => response.data)
}
